module.exports = __webpack_public_path__ + "static/media/HdO.fa42c0dc.jpeg";